enum EResourceType {
    
    PARALLAX = 1,
    PATTERN,
    OUTER_IMAGE,
    INNER_IMAGE,
    VIDEO,
    IMAGE,
    DATA,
    STATISTIC_DATA_SHEET,
    ICON,
    LOGO_DEFAULT,
    LOGO_ONLY,
    LOGO_WITH_BOTTOM_TEXT,

}

export default EResourceType;
